import { TGuid } from '@core/helpers';
import { EProfileTypeDTO } from './_index';
import { EProfileTagsDTO } from './consts/profile-tags';

export interface IProfileTagDTO {
  id: TGuid;
  name: string;
  disable_scheduling: boolean;
  disable_live_queue: boolean;
  disable_access: boolean;
  cnes: ICnes;
  public_name: string;
  cnes_code: string;
  public: boolean;
  profile_tag_type?: EProfileTagsDTO;
}

export interface IProfileTagCreateDTO {
  name: string;
  profile_type: EProfileTypeDTO;
  profile_tag_type?: EProfileTypeDTO;
  disable_scheduling: boolean;
  disable_live_queue: boolean;
  disable_access: boolean;
  cnes_code: string;
  public_name: string;
  public: boolean;
}

export interface IProfileTagCreateData {
  name: string;
  profile_type: EProfileTypeDTO;
  profile_tag_type?: EProfileTypeDTO;
  disable_scheduling: boolean;
  disable_live_queue: boolean;
  disable_access: boolean;
  cnes_code: string;
  public_name: string;
  public: boolean;
}

export interface IProfileTag {
  id: TGuid;
  name: string;
  disable_scheduling: boolean;
  disable_live_queue: boolean;
  disable_access: boolean;
  cnes: ICnes;
  public_name: string;
  public: boolean;
  cnes_code: string;
  profile_tag_type?: EProfileTagsDTO;
}

export interface ICnesResponse {
  items: ICnes[];
  totalItemsCount: number;
}

export interface ICnes {
  cnes_code: string;
  sigla_estado: string;
  municipio: string;
  nome_estabelecimento: string;
  tag_id: string;
}

export interface ICityCnes {
  municipio: string;
  sigla_estado: string;
}

export interface IUnit {
  cnes_code: string;
  nome_estabelecimento: string;
  group_id?: string;
}

export class ProfileTagViewModelFactory {
  static createGetViewModel(dto: IProfileTagDTO): IProfileTag {
    return {
      ...dto,
    };
  }

  static createPostDTO(data: IProfileTagCreateData): IProfileTagCreateDTO {
    return {
      ...data,
    };
  }
}
